import { Controller } from '@hotwired/stimulus';
import { MDCTopAppBar } from '@material/top-app-bar';
import { MDCDrawer } from '@material/drawer';

export default class extends Controller {
  connect() {
    this.topAppBar = new MDCTopAppBar(this.element);
    this.drawerMenu();
  }

  disconnect() {
    if (this.topAppBar) {
      this.topAppBar.destroy();
    }
  }

  drawerMenu() {
    const topAppBar = MDCTopAppBar.attachTo(document.getElementById('app-bar'));
    const drawerElement = document.querySelector('.mdc-drawer');

    if (drawerElement) {
      const drawer = MDCDrawer.attachTo(drawerElement);
      topAppBar.setScrollTarget(document.getElementById('main-content'));
      topAppBar.listen('MDCTopAppBar:nav', () => {
        drawer.open = !drawer.open;
      });
    }
  }
}
